import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';

class SimpleListItem extends Component {
  render() {
    return (
      <div className="side-menu-list-obj">
        {/*inner wrapper to generate side color border*/}
        <div
          className="list-obj-inner-wrapper"
          style={{ borderLeftColor: this.props.color || '#1679c7' }}
        >
          <div className="obj-title primary-text">{this.props.text}</div>
        </div>
      </div>
    );
  }
}

export default SimpleListItem;
